import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { ToastrService } from 'ngx-toastr'; // Or any other toast library

@Injectable()
export class ModerationInterceptor implements HttpInterceptor {
    constructor(private toastr: ToastrService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap({
                error: (error: HttpErrorResponse) => {
                    // You can also handle specific error conditions here
                    if (error.status === 400) { //} && error.error?.message === 'RESTRICTED_CONTENT') {
                        if (error.error) {
                            let parsedError: any = {};

                            if (typeof error.error === 'string') {
                                try {
                                    parsedError = JSON.parse(error.error);
                                } catch {
                                    parsedError = { message: error.error };
                                }
                            } else {
                                parsedError = error.error;
                            }

                            if (parsedError?.message === 'RESTRICTED_CONTENT') {
                                this.toastr.error('Update Failed. Your changes couldn’t be saved because they may contain words or phrases restricted by our organization. If you believe this is an error, please contact Customer Support at 888-557-7177.');
                            }
                        }
                    }
                }
            })
        );
    }
}
